/**
 * Supported currencies for billing and payments
 * List of currencies available for user selection
 * Subset of all currencies (see currencies.ts for complete list)
 */

/** Currency option for selection */
export interface CurrencyOption {
  code: string
  name: string
}

export const SUPPORTED_CURRENCIES: readonly CurrencyOption[] = [
  { code: 'AUD', name: 'Australian Dollar' },
  { code: 'BRL', name: 'Brazilian Real' },
  { code: 'GBP', name: 'British Pound' },
  { code: 'CAD', name: 'Canadian Dollar' },
  { code: 'CLP', name: 'Chilean Peso' },
  { code: 'EUR', name: 'Euro' },
  { code: 'INR', name: 'Indian Rupee' },
  { code: 'JPY', name: 'Japanese Yen' },
  { code: 'KRW', name: 'South Korean Won' },
  { code: 'MXN', name: 'Mexican Peso' },
  { code: 'NZD', name: 'New Zealand Dollar' },
  { code: 'PLN', name: 'Polish Zloty' },
  { code: 'SGD', name: 'Singapore Dollar' },
  { code: 'CHF', name: 'Swiss Franc' },
  { code: 'TRY', name: 'Turkish Lira' },
  { code: 'USD', name: 'US Dollar' },
] as const

/** Union type of supported currency codes */
export type SupportedCurrencyCode = typeof SUPPORTED_CURRENCIES[number]['code']
// Type: 'AUD' | 'BRL' | 'GBP' | 'CAD' | 'CLP' | 'EUR' | 'INR' | 'JPY' | 'KRW' | 'MXN' | 'NZD' | 'PLN' | 'SGD' | 'CHF' | 'TRY' | 'USD'
